import { executeQuery } from '@/components/commons/utils';
import { gql } from '@apollo/client/core';
import { ref } from 'vue';
import useProduct from '@/compositions/useProduct';

const PERSONALIZATION_QUERY = gql`
  query PERSONALIZATION {
    getProductRecommendations {
      success
      message
      productThumbnail {
        hashKey
        skuNo
        title
        slug
        imageUrl
        onSale
        onClearance
        price {
          currencyCode
          sale
          price
          retail
          clearance
          bundlePrice
        }
        variantImageUrl
      }
    }
  }
`;

const personalizationProducts = ref([]);

export default function usePersonalization() {
  async function loadPersonalizationProducts() {
    const { getProductRecommendations } = await executeQuery(PERSONALIZATION_QUERY);

    const { success, productThumbnail } = JSON.parse(JSON.stringify(getProductRecommendations));

    if (success && productThumbnail?.length) {
      const { formatProduct } = useProduct();
      const products = productThumbnail?.map(formatProduct);

      personalizationProducts.value = products;
    }
  }

  return {
    personalizationProducts,
    loadPersonalizationProducts,
  };
}
